export const VISA = 'VISA';
export const MASTERCARD = 'MC';
export const AMEX = 'AMEX';
